export default {
  name: 'reportesJoin',
  component: () => 
    import(
      /* webpackChunkName: "reportesJoinLayout" */ "@/modules/reportesJoin/layouts/reportesJoinLayout.vue"
    ),
  redirect: "/reportesJoin/agentes",
  children: [
    {
      path: "general-join",
      name: "reportes-general-join",
      component: () =>
        import(
          /* webpackChunkName: "general" */ "@/modules/reportesJoin/pages/General.vue"
        ),
    },
    {
      path: "agentes",
      name: "reportes-agentes",
      component: () =>
        import(
          /* webpackChunkName: "agentes" */ "@/modules/reportesJoin/pages/Agentes.vue"
        ),
    },
    {
      path: "recibidas",
      name: "recibidas-agentes",
      component: () =>
        import(
          /* webpackChunkName: "recibidas" */ "@/modules/reportesJoin/pages/TransferenciasManuales.vue"
        ),
    },
    {
      path: "tiempo-respuesta",
      name: "tiempo-respuesta",
      component: () =>
        import(
          /* webpackChunkName: "agentes" */ "@/modules/reportesJoin/pages/TiempoRespuesta.vue"
        ),
    },
    {
      path: "conversaciones",
      name: "conversaciones",
      component: () =>
        import(
          /* webpackChunkName: "conversaciones" */ "@/modules/reportesJoin/pages/Intervenciones.vue"
        ),
    },
    {
      path: "conversaciones-in-out",
      name: "conversaciones-in-out",
      component: () =>
        import(
          /* webpackChunkName: "conversaciones-in-out" */ "@/modules/reportesJoin/pages/Interacciones.vue"
        ),
    },
    {
      path: "opciones-general",
      name: "opciones-general",
      component: () =>
        import(
          /* webpackChunkName: "opciones-general" */ "@/modules/reportesJoin/pages/DetalleTraficoBot.vue"
        ),
    },
    {
      path: "opciones",
      name: "opciones-bot",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/TraficoBot.vue"
        ),
    },
    {
      path: "respuestas-bot",
      name: "respuestas-bot",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/RespuestasBot.vue"
        ),
    },
    {
      path: "etiquetas",
      name: "reporte-etiquetas",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/Etiquetas.vue"
        ),
    },
    {
      path: "campanias",
      name: "reporte-campanias",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/Campanias.vue"
        ),
    },
    {
      path: "interacciones-campanias",
      name: "reporte-interacciones-campanias",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/InteraccionesCampanias.vue"
        ),
    },
    {
      path: "encuestas",
      name: "reporte-encuestas",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/Encuestas.vue"
        ),
    },
    {
      path: "cierres",
      name: "reporte-cierre",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/Cierres.vue"
        ),
    },
    {
      path: "balance",
      name: "reporte-balance",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/Balance.vue"
        ),
    },
    {
      path: "reporte-bot-activo",
      name: "reporte-bot-activo",
      component: () =>
        import(
          /* webpackChunkName: "opciones" */ "@/modules/reportesJoin/pages/BotActivo.vue"
        ),
    },
    {
      path: "pbx-join",
      name: "reportes-pbx-join",
      component: () =>
        import(
          /* webpackChunkName: "pbx-join" */ "@/modules/reportesJoin/pages/Pbx_Join.vue"
        ),
    },
  ],
}